
export default {
  name: 'ListingMattressFinderTitle',
  props: {
    stepsLength: {
      type: Number,
      default() {
        return 3;
      },
    },
    stepsProgress: {
      type: Array,
      default() {
        return [];
      },
    },
    currentStep: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
